import {Component, Input, OnDestroy, ViewChild, ViewEncapsulation} from '@angular/core';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { Utils } from 'app/infrastructure/utils';
import { PanelsName } from 'app/enums/panels.enum';
import { Subject } from 'rxjs';

@Component({
    selector     : 'app-notifications-panel',
    templateUrl  : './notifications-panel.component.html',
    styleUrls    : ['./notifications-panel.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GeneralNotificationsPanelComponent implements OnDestroy {

    @Input() panel: string;
    panelNames = PanelsName;

    refreshPanelDataSubject: Subject<void> = new Subject<void>();
    isLoading: boolean = false;

    /**
     * Constructor
     */
    constructor(private fuseSidebarService: FuseSidebarService) {}

    ngOnDestroy(): void {
        this.fuseSidebarService.getSidebar(this.panel).close();
    }

    toggleSidebarOpen(key: string): void {
        if (Utils.isNullOrWhiteSpace(key)) return;
        this.fuseSidebarService.getSidebar(key).toggleOpen();
    }
}
